import { ShoppingCart } from 'lucide-react';

const PurchaseEmpty = () => {
  return (
    <div
      className="
        flex
        min-h-[320px]
        flex-col
        items-center
        justify-center

        px-6

        text-center
      "
    >
      <span
        className="
          rounded-xl

          border
          border-primary/15

          bg-primary/10

          p-4

          text-primary

          dark:border-primary/25
          dark:bg-primary/15
        "
      >
        <ShoppingCart className="h-8 w-8" />
      </span>

      <h3
        className="
          mt-4

          text-lg
          font-semibold
          text-black

          dark:text-white
        "
      >
        No hay compras para mostrar
      </h3>

      <p
        className="
          mt-1
          max-w-md

          text-sm
          text-bodydark2

          dark:text-bodydark
        "
      >
        Cree una compra nueva o cambie los filtros
        seleccionados.
      </p>
    </div>
  );
};

export default PurchaseEmpty;